import axios from 'axios';

import {store} from '../store';
import { LANGUAGE_KEY, REVREX_APP_BASE_URL } from '../resources/constants';

// Add response interceptor
axios.interceptors.response.use(
  response => response,
  async error => {
    const errorType = error.response?.data?.error?.type;
    // 'permission_denied' is an RBAC refusal, not a broken session — the caller shows a
    // message instead of the user being bounced out of the GL app.
    const isValidationForbidden = ['year_locked', 'qbo_locked', 'permission_denied'].includes(errorType);

    if (error.response?.status === 403 && !isValidationForbidden) {
      window.location.href = REVREX_APP_BASE_URL || "";
      return Promise.reject(error); // Ensure the error is still rejected
    }
    return Promise.reject(error); // Reject other errors to allow them to propagate to catch blocks
  }
)

// axios.defaults.withCredentials = true;
const getAccessToken=()=>{
  return store.getState().user.accessToken;
}

export class CallApi {
  static GET(url: string, data: any = {}, isAuth: boolean = false) {
    return new Promise((resolve, reject) => {
      const token = getAccessToken();
      let headers:any = {
        // "ngrok-skip-browser-warning": "69420",
        "ngrok-skip-browser-warning": "true",
      }
      if(isAuth == true)
      {
        headers['Authorization'] =  'Bearer ' + token;
      }
      let language = localStorage.getItem(LANGUAGE_KEY);
      if(language)
      {
        headers['Accept-Language'] = language;
      } else {
        headers['Accept-Language'] = 'en';
      }
      return axios({method: 'GET', url, headers, data}).then((success: any) => {
        return resolve(success);
      }).catch(error => {
        return reject(error.response || error);
      });
    });
  }

  static POST(url: string, data: any = {}, isAuth: boolean = false) {
    return new Promise((resolve, reject) => {
      const token = getAccessToken();
      let headers:any = {
        // "ngrok-skip-browser-warning": "69420",
      }
      if(isAuth == true)
      {
        headers['Authorization'] =  'Bearer ' + token;
      }
      let language = localStorage.getItem(LANGUAGE_KEY);
      if(language)
      {
        headers['Accept-Language'] = language;
      } else {
        headers['Accept-Language'] = 'en';
      }
      
      // If data is FormData, let axios set Content-Type automatically (includes boundary)
      if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }
      
      return axios({method: 'POST', url, headers, data})
        .then(async success => {
          return resolve(success);
        })
        .catch(error => {
          return reject(error.response || error);
        });
    });
  }

  static PUT(url: string, data: any = {}, isAuth: boolean = false) {
    return new Promise((resolve, reject) => {
      const token = getAccessToken();
      let headers:any = {
        // "ngrok-skip-browser-warning": "69420",
      }
      if(isAuth == true)
      {
        headers['Authorization'] =  'Bearer ' + token;
      }
      let language = localStorage.getItem(LANGUAGE_KEY);
      if(language)
      {
        headers['Accept-Language'] = language;
      } else {
        headers['Accept-Language'] = 'en';
      }
      return axios({ method: 'PUT', url, headers, data }).then(success => {
        return resolve(success);
      }).catch(error => {
        return reject(error.response || error);
      });
    });
  }

  static DELETE(url: string, data: any = {}, isAuth: boolean = false) {
    return new Promise((resolve, reject) => {
      const token = getAccessToken();
      let headers:any = {
        // "ngrok-skip-browser-warning": "69420",
      }
      if(isAuth == true)
      {
        headers['Authorization'] =  'Bearer ' + token;
      }
      let language = localStorage.getItem(LANGUAGE_KEY);
      if(language)
      {
        headers['Accept-Language'] = language;
      } else {
        headers['Accept-Language'] = 'en';
      }
      return axios({ method: 'DELETE', url, headers, data }).then(success => {
        return resolve(success);
      }).catch(error => {
        return reject(error.response || error);
      });
    });
  }

  static DOWNLOAD(url: string, data: any = {}, isAuth: boolean = false) {
    return new Promise((resolve, reject) => {
      const token = getAccessToken();
      let headers:any = {
        'Content-Type': 'application/pdf'
      }
      if(isAuth == true)
      {
        headers['Authorization'] =  'Bearer ' + token;
      }
      let language = localStorage.getItem(LANGUAGE_KEY);
      if(language)
      {
        headers['Accept-Language'] = language;
      } else {
        headers['Accept-Language'] = 'en';
      }

      return axios({method: 'GET', url, headers, responseType: 'blob', data}).then((success: any) => {
        return resolve(success.data);
      }).catch(error => {
        return reject(error.response || error);
      });
    });
  }

  static DOWNLOAD_CSV(url: string, data: any = {}, isAuth: boolean = false) {
    return new Promise((resolve, reject) => {
      const token = getAccessToken();
      let headers: any = {
        'Accept': 'text/csv',
      }
      if (isAuth == true) {
        headers['Authorization'] = 'Bearer ' + token;
      }
      let language = localStorage.getItem(LANGUAGE_KEY);
      if(language)
      {
        headers['Accept-Language'] = language;
      } else {
        headers['Accept-Language'] = 'en';
      }

      return axios({
        method: 'GET', 
        url, 
        headers, 
        responseType: 'blob', 
        data
      }).then((success: any) => {
        return resolve(success.data);
      }).catch(error => {
        return reject(error.response || error);
      });
    });
  }
}
